import { render, staticRenderFns } from "./SubpageUsageLegacy.vue?vue&type=template&id=699ec996&"
import script from "./SubpageUsageLegacy.vue?vue&type=script&lang=js&"
export * from "./SubpageUsageLegacy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/bamboo-agent-home/xml-data/build-dir/WWW-WWW-JOB1/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('699ec996')) {
      api.createRecord('699ec996', component.options)
    } else {
      api.reload('699ec996', component.options)
    }
    module.hot.accept("./SubpageUsageLegacy.vue?vue&type=template&id=699ec996&", function () {
      api.rerender('699ec996', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/src/components/myaccount/usage-legacy/SubpageUsageLegacy.vue"
export default component.exports